//
//
//
//
//
//

export default {
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/MyCheckStyle.vue